module.exports = __webpack_public_path__ + "img/proyecto_9.f2c71e65.webp";